/* eslint-disable react/jsx-pascal-case */
import React, { forwardRef, useImperativeHandle } from "react"
import { useState, useEffect, useRef } from "react"

import BaseCanvasEdit0 from "./base_canvas_edit_0"
import BaseCanvasEdit1 from "./base_canvas_edit_1"
import BaseCanvasEdit2 from "./base_canvas_edit_2"
import BaseCanvasEdit3_1 from "./base_canvas_edit_3_1"
import axios from "axios"
import { Spinner } from "../ui/spinner"
import { useCRUDController, TempDataProvider, useGlobalTempStore,Button } from "./ot"

const isEmptyFunction = (fn) => {
    return typeof fn === 'function' && fn.toString().replace(/\s/g, '') === '()=>{}';
}

const BaseCanvasEdit = forwardRef(({
    base_on_classify_structure = false, //使用目前最新結構 預設 false
    componentDefinitionsAPIRoute = "/utility/component_definitions",
    componentDefinitionsApiRoute = null,
    componentAttributesAPIRoute = "/utility/component_attributes",
    componentAttributesApiRoute = null,
    formColumnApiRoute = '/process_management/backend/process_document/form/form_column',
    contentId,
    sourceId,
    isNewContent = false,
    allowAdvancedLayout = true,
    isTemplateMode = false, // 預設為內容編輯模式
    propsCanvasElement = [],
    onSave = () => { },
    aiGenerateAPIRoute = "/utility/ai_produce",

    // Card header props
    card_header_title = "編輯文案內容",
    card_header_description = "使用畫布編輯器拖放元件來創建您的文案",
    card_header_icon = true,
    card_header_className = "border-green-200 dark:border-green-800 bg-gradient-to-br from-green-50 to-transparent dark:from-green-950/30 dark:to-transparent",
    card_header_showSaveButton = true,
    card_header_showAIButton = true,
    card_header_showBindFormButton = false,
    card_header_saveButtonName = "儲存文案",
    card_header_aiButtonName = "AI一鍵生成",
    card_header_styles = {},
    aiGenerateQuantityRecommendationsAPIRoute = "/utility/ai_produce/controller/quantity_recommendations",

    target = "文案",
    propsSelectionOptions = [],
    propsLoading = null, //上層控制loading 狀態
    showTabkey = ['setting_tool', "properties", "ai",], // ["properties", "ai", "setting_tool"]
    tools = [],
    propsSetSelectionOptions = () => { },
    onChange = () => { },// 主要回傳 canvasElement 變更時資料給上層
    documentFiveWAPI = "/utility/document/base_view",
    fiveWResponseAPI = "/utility/response/cache",
    five_w_id,
    canvas_content_id,
    dropDownDocumentAPiRoute = '/utility/document/base_view', // /utility/document?dropdown=1
    toolBarRender = () => { return [] },
    fiveWResponseData = [],
    allDocumentData = [],
}, ref) => {
    const finalComponentDefinitionsApiRoute = componentDefinitionsApiRoute ?? componentDefinitionsAPIRoute
    const finalComponentAttributesApiRoute = componentAttributesApiRoute ?? componentAttributesAPIRoute
    const [isLoading, setIsLoading] = useState(false)
    const [componentData, setComponentData] = useState([]);
    const [selectedComponentId, setSelectedComponentId] = useState(null);
    const [selectedElement, setSelectedElement] = useState(null);
    const [canvasElement, setCanvasElement] = useState([]);
    const [selectedCanvasElement, setSelectedCanvasElement] = useState([]);
    const [componentAttributesData, setComponentAttributesData] = useState([]);
    const [componentCommonAttributesData, setComponentCommonAttributesData] = useState([]);
    const [elementType, setElementType] = useState("");
    const [canvasPageSelect, setCanvasPageSelect] = useState(null);
    const [canvasPage, setCanvasPage] = useState([]);
    const baseCanvasEdit2Ref = useRef()
    const selectCanvasEditElementRef = useRef() // 取代 setSelectedCanvasElement 的時序問題
    const isOnSave = isEmptyFunction(onSave)

    // 暴露 captureThumbnail 方法給父組件
    useImperativeHandle(ref, () => ({
        captureThumbnail: async () => {
            return await baseCanvasEdit2Ref.current?.captureThumbnail?.()
        }
    }), [])

    const dropDownDocumentController = useCRUDController({
        apiRoute: dropDownDocumentAPiRoute
    })

    const onCanvasElementChange = () => {
        if (isOnSave) {
            if (canvas_content_id) {
                axios.patch(`/utility/canvas/content`, [{ canvas_content_id, content: JSON.stringify(canvasElement) }])
                    .then((res) => {
                        onSave(res.data)
                    })
                    .catch((err) => {
                        console.error("Error: ", err)
                    })
            } else {
                axios.post(`/utility/canvas/content`, [{ content: JSON.stringify(canvasElement) }])
                    .then((res) => {
                        onSave(res.data)
                    })
                    .catch((err) => {
                        console.error("Error: ", err)
                    })
            }
        } else {
            onSave()
        }
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === 'get') {
                // setComponentAttributesData(values)
            } else if (axiosMode === "post") {
            } else if (axiosMode === "patch") {
            } else if (axiosMode === "delete") {
            }
        } else if (status === "error") {
            // if (axiosMode === "post") {
            //     actionRef.current.reloadAndRest();
            // } else if (axiosMode === "patch") {
            //     actionRef.current.reloadAndRest();
            // } else if (axiosMode === "delete") {
            //     actionRef.current.reloadAndRest();
            // }
        }
    };
    const onCommonAttributeFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === 'get') {
                setComponentCommonAttributesData(values.filter((item) => item?.component_definitions_id === null))
            } else if (axiosMode === "post") {
            } else if (axiosMode === "patch") {
            } else if (axiosMode === "delete") {
            }
        } else if (status === "error") {
        }
    };

    const ComponentDefinitionsControllers = useCRUDController({ apiRoute: finalComponentDefinitionsApiRoute })
    const ComponentCommonAttributesControllers = useCRUDController({ apiRoute: finalComponentAttributesApiRoute, onFinish: onCommonAttributeFinish })
    const ComponentAttributesControllers = useCRUDController({ apiRoute: finalComponentAttributesApiRoute, onFinish })

    const changeSelectedComponent = (selectedComponentId) => {
        setSelectedComponentId(selectedComponentId)
        // let values = componentCommonAttributesData.filter((ele) => {
        //     return ele?.component_definitions_id === selectedComponentId
        // })
        // setComponentAttributesData(values)
        let componentAttributesData = (ComponentAttributesControllers?.ResponseData || []).filter((item) => parseInt(item?.component_definitions_id) === parseInt(selectedComponentId))
        setComponentAttributesData(componentAttributesData)
        // ComponentAttributesControllers.getData({ "component_definitions_id": selectedComponentId }, { useCancelToken: false });
    }
    const onChangeComponentEffect = (style, modifyType) => {

        setCanvasElement((prevPages) => {
            let temp = prevPages.map((page) => {
                if (page.id !== canvasPageSelect) return { ...page };
                const updatedElements = page.elements.map((item) => {
                    let selectCanvasEditElementId = selectCanvasEditElementRef.current?.id
                    if (item?.id === selectCanvasEditElementId) {
                        if (modifyType === "style") {
                            selectCanvasEditElementRef.current = {
                                ...item,
                                style: {
                                    ...item.style,
                                    ...style,
                                },
                            }

                            return {
                                ...item,
                                style: {
                                    ...item.style,
                                    ...style,
                                },
                            };
                        } else if (modifyType === "content") {
                            selectCanvasEditElementRef.current = {
                                ...item,
                                content: style,
                            }
                            return {
                                ...item,
                                content: style,
                            };
                        } else if (modifyType === "qrcode") {
                            selectCanvasEditElementRef.current = {
                                ...item,
                                size: style?.size ?? item?.size,
                                style: {
                                    ...item.style,
                                    ...style?.style,
                                },
                            }
                            return {
                                ...item,
                                size: style?.size ?? item?.size,
                                style: {
                                    ...item.style,
                                    ...style?.style,
                                },
                            };
                        }
                        else if (modifyType === "location") {
                            selectCanvasEditElementRef.current = {
                                ...item,
                                location_type: style?.location_type,
                            }
                            return {
                                ...item,
                                location_type: style?.location_type,
                            };
                        }
                        else {
                            selectCanvasEditElementRef.current = {
                                ...item,
                                [modifyType]: style,
                            }
                            return {
                                ...item,
                                [modifyType]: style,
                            };
                        }
                    }

                    return item;
                });
                return {
                    ...page,
                    elements: updatedElements,
                };
            })
            if (baseCanvasEdit2Ref.current) {
                baseCanvasEdit2Ref.current.onUpdate(temp)
            }
            return prevPages
        });
    }
    const applyAIContentToSelectedElement = (aiContent, keepHtml = true) => {
        // const finalContent = keepHtml
        // ? aiContent
        // : aiContent.replace(/<\/?(?!iframe|div)[^>]+(>|$)/g, "");

        // const parsedContent = keepHtml && !isNaN(finalContent)
        // ? Number(finalContent)
        // : finalContent;

        setCanvasElement((prevPages) => {
            return prevPages.map((page) => {
                if (page.id !== canvasPageSelect) return { ...page };
                const updatedElements = page?.elements.map((item) => {
                    let selectCanvasEditElementId = selectCanvasEditElementRef.current?.id
                    if (item?.id === selectCanvasEditElementId) {
                        return {
                            ...item,
                            content: aiContent?.output,
                            style: aiContent?.css
                        };
                    }
                    return item;
                });
                return {
                    ...page,
                    elements: updatedElements,
                };
            })
        });
        let temp = canvasElement.map((page) => {
            if (page?.id !== canvasPageSelect) {
                return { ...page }
            }
            else {
                const updatedElements = page?.elements.map((item) => {

                    let selectCanvasEditElementId = selectCanvasEditElementRef.current?.id
                    if (item?.id === selectCanvasEditElementId) {
                        selectCanvasEditElementRef.current = { ...item }
                        return {
                            ...item,
                            content: aiContent?.output,
                            style: aiContent?.css
                        };
                    }
                    else {
                        return item;
                    }
                });
                return {
                    ...page,
                    elements: updatedElements,
                };
            }
        })
        if (baseCanvasEdit2Ref.current) {
            baseCanvasEdit2Ref.current.onUpdate(temp);
        }
    }


    /* 處理 AI 一鍵生成結果 */
    const getDefaultContentByType = (type, message) => {
        if (!message || !message.output) return "";
        switch (type) {
            case "title":
            case "title_test":
                return message.output[0] || "";
            case "text-content":
                return message.output[0] || "";
            case "photo":
                return message.output[0] || "";
            case "hashtag":
                return message.output.join(" ");
            case "button":
                return message.output[0] || "";
            case "datetime":
                return message.output[0] || "";
            default:
                return "";
        }
    };
    const getDefaultStyleByType = (type, message) => {
        return message?.css || {};
    };
    const handleComponentQuantityRecommendationsResultChange = (resultArray) => {
        // resultArray: 你的 prompt array
        // component_definitions_id: 你要指定的 id
        return resultArray?.data?.map((item, idx) => {
            const type = item.target;
            const message = Array.isArray(item.message) ? item.message[0] : {};
            const newId = `${type}_${Date.now()}_${idx}`;
            // 這裡可以根據需求調整 x, y
            const x = 50 + idx * 10;
            const y = 100 + idx * 70;
            return {
                component_definitions_id: item?.component_definitions_id,
                id: newId,
                type,
                content: getDefaultContentByType(type, message),
                x,
                y,
                width: 300,
                height: 60,
                style: getDefaultStyleByType(type, message),
            };
        });
    };
    const isShowBindFormButton = (canvasElement) => {
        let elements = canvasElement?.flatMap(page => page?.elements || []) || []
        let elementFind = elements.find((element) => {
            let form_form_column_data = element?.form_form_column_data || []
            let form_form_column_data_first = form_form_column_data.find((_) => true)
            let code = form_form_column_data_first?.code
            return code == "綁定表單"
        })
        if (elementFind) {
            return true
        }
        else {
            return false
        }

    }
    const isShowBindAdPlanButton = (canvasElement) => {
        let elements = canvasElement?.flatMap(page => page?.elements || []) || []
        let elementFind = elements.find((element) => {
            let form_form_column_data = element?.form_form_column_data || []
            let form_form_column_data_first = form_form_column_data.find((_) => true)
            let code = form_form_column_data_first?.code
            return code == "綁定文案"
        })
        if (elementFind) {
            return true
        }
        else {
            return false
        }

    }
    const getBindFormColumnSourceDocumentId = (canvasElement) => {
        let elements = canvasElement?.flatMap(page => page?.elements || []) || []
        let elementFind = elements.find((element) => {
            let form_form_column_data = element?.form_form_column_data || []
            let form_form_column_data_first = form_form_column_data.find((_) => true)
            let code = form_form_column_data_first?.code
            return code == "綁定表單"
        })
        if (elementFind) {
            let form_form_column_data = elementFind?.form_form_column_data || []
            let form_form_column_data_first = form_form_column_data.find((_) => true)
            let form_column_source_data = form_form_column_data_first?.form_column_source_data || []
            let document_source_data = form_column_source_data.find((_) => true)?.document_source_data || []
            let document_id = document_source_data?.find((_) => true)?.document_id
            return document_id
        }
        else {
            return null
        }
    }
    const getBindAdPlanSourceDocumentId = (canvasElement) => {
        let elements = canvasElement?.flatMap(page => page?.elements || []) || []
        let elementFind = elements.find((element) => {
            let form_form_column_data = element?.form_form_column_data || []
            let form_form_column_data_first = form_form_column_data.find((_) => true)
            let code = form_form_column_data_first?.code
            return code == "綁定文案"
        })
        if (elementFind) {
            let form_form_column_data = elementFind?.form_form_column_data || []
            let form_form_column_data_first = form_form_column_data.find((_) => true)
            let form_column_source_data = form_form_column_data_first?.form_column_source_data || []
            let document_source_data = form_column_source_data.find((_) => true)?.document_source_data || []
            let document_id = document_source_data?.find((_) => true)?.document_id
            return document_id
        }
        else {
            return null
        }
    }
    /* 處理 AI 一鍵生成結果 */


    useEffect(() => {
        if (!selectedComponentId) {
            setSelectedElement(null)
            return
        }
        let selectData = ComponentDefinitionsControllers.ResponseData?.filter((item) => parseInt(item?.component_definitions_id) === parseInt(selectedComponentId))
        let dataFirst = selectData?.find((_) => true) || null
        setSelectedElement(selectData)
        setElementType(dataFirst?.component_type)
        // axios.get(`/utility/component_definitions?component_definitions_id=${selectedComponentId}`)
        //     .then((res) => {
        //         setSelectedElement(res.data.data)
        //         setElementType(res.data.data?.[0]?.component_type)
        //     })
        //     .catch((err) => {
        //         setSelectedElement(null)
        //     })
    }, [selectedComponentId])

    useEffect(() => {
        // console.log("selectedElement 更新：", selectedElement)
    }, [selectedElement])
    useEffect(() => {
        // console.log("canva1q2sElement 更新：", canvasElement)
        onChange(canvasElement) //當有變更回傳給上層
    }, [canvasElement])
    useEffect(() => {
        // console.log("componentCommonAttributesData 更新：", componentCommonAttributesData)
    }, [componentCommonAttributesData])
    useEffect(() => {
        // console.log("canvasPageSelect 更新：", canvasPageSelect)
    }, [canvasPageSelect])
    useEffect(() => {
        // console.log("canvasPage 更新：", canvasPage)
    }, [canvasPage])
    useEffect(() => {
        if (propsCanvasElement?.length === 0) return;
        // setCanvasElement(propsCanvasElement)
        if (baseCanvasEdit2Ref.current) {
            baseCanvasEdit2Ref.current.onUpdate(propsCanvasElement || [])
        }
    }, [propsCanvasElement])
    useEffect(() => {
        let params = {

        }
        if (base_on_classify_structure) {
            params.base_on_classify_structure = 1
        }
        ComponentDefinitionsControllers.getData({
            ...params
        })
            .then((response) => {
                let data = response?.data || []
                if (finalComponentDefinitionsApiRoute === "/utility/component_definitions" && !base_on_classify_structure) {
                    // 處理 基底 componentDefinitionsAPIRoute 的邏輯
                    setComponentData(data)
                }
                else {
                    let componentDefinitionsData = []
                    // 處理其他 API 路徑的邏輯 或新結構基底
                    data.forEach((item) => {
                        let component_definitions_classify_structure_type_data = item?.component_definitions_classify_structure_type_data || []
                        let component_definitions_classify_structure_type_data_first = component_definitions_classify_structure_type_data?.find((_) => true)
                        componentDefinitionsData.push({
                            title: item?.title,
                            ...component_definitions_classify_structure_type_data_first
                        } || {})
                    })
                    setComponentData(componentDefinitionsData)
                }
            })
        ComponentAttributesControllers.getData({});
        ComponentCommonAttributesControllers.getData({});

    }, [])

    useEffect(() => {
        dropDownDocumentController.getData()
    }, [])

    return (
        <div className="space-y-6">
            <BaseCanvasEdit0
                toolBarRender={() => {
                    return [
                        ...toolBarRender(),
                    ]
                }}
                title={card_header_title}
                description={card_header_description}
                icon={card_header_icon}
                className={card_header_className}
                showSaveButton={card_header_showSaveButton}
                showAIButton={card_header_showAIButton}
                showBindFormButton={card_header_showBindFormButton || isShowBindFormButton(canvasElement)}
                showBindAdPlanButton={card_header_showBindFormButton || isShowBindAdPlanButton(canvasElement)}
                saveButtonName={card_header_saveButtonName}
                aiButtonName={card_header_aiButtonName}
                styles={card_header_styles}
                onSaveClick={() => {
                    onCanvasElementChange()
                }}
                aiGenerateQuantityRecommendationsAPIRoute={aiGenerateQuantityRecommendationsAPIRoute}

                target={target}
                propsSelectionOptions={propsSelectionOptions}
                propsSetSelectionOptions={propsSetSelectionOptions}
                propsComponentData={componentData}

                onComponentQuantityRecommendationsResultChange={(values) => {
                    const newElements =values?.data ||[]
                    // 你可以 setCanvasElement 或做其他操作
                    // 只保留一個 page，並把 elements 設成 newElements
                    const newPageId = `page-${Date.now()}`;
                    const newPage = {
                        id: newPageId,
                        name: "頁面 1",
                        elements: newElements,
                        zoom: 1,
                    };
                    setCanvasElement([newPage]);
                    if (baseCanvasEdit2Ref.current) {
                        baseCanvasEdit2Ref.current.onUpdate([newPage])
                    }
                    setCanvasPageSelect(newPageId);
                }}
                bindFormColumnSourceDocumentId={getBindFormColumnSourceDocumentId(canvasElement)}
                bindAdPlanSourceDocumentId={getBindAdPlanSourceDocumentId(canvasElement)}
                onBindAdPlanSourceDocumentIdChange={(changedDocumentId) => {
                    setCanvasElement((prevPages) => {
                        let temp = prevPages.map((page) => {
                            if (page?.id !== canvasPageSelect) {
                                return { ...page }
                            }
                            else {
                                const updatedElements = page?.elements.map((item) => {
                                    let form_form_column_data = item?.form_form_column_data || []
                                    let form_form_column_data_first = form_form_column_data.find((_) => true) || {}
                                    let code = form_form_column_data_first?.code || ""
                                    if (code !== "綁定文案") {
                                        return item;
                                    }
                                    let form_column_source_data = form_form_column_data_first?.form_column_source_data || [{}]
                                    let document_source_data = form_column_source_data.find((_) => true)?.document_source_data || [{}]
                                    let updated_document_source_data = document_source_data.map((doc) => {
                                        return {
                                            ...doc,
                                            document_id: changedDocumentId
                                        }
                                    })
                                    let updated_form_column_source_data = form_column_source_data.map((form_column) => {
                                        return {
                                            ...form_column,
                                            document_source_data: updated_document_source_data
                                        }
                                    })
                                    let updated_form_form_column_data = form_form_column_data.map((form_column) => {
                                        return {
                                            ...form_column,
                                            form_column_source: true,
                                            form_column_source_data: updated_form_column_source_data
                                        }
                                    })

                                    return {
                                        ...item,
                                        form_form_column_data: updated_form_form_column_data
                                    };
                                });
                                return {
                                    ...page,
                                    elements: updatedElements,
                                };
                            }

                        })

                        if (baseCanvasEdit2Ref.current) {
                            baseCanvasEdit2Ref.current.onUpdate(temp)
                        }
                        return prevPages
                    });
                }}
                onBindFormColumnSourceDocumentIdChange={(changedDocumentId) => {
                    setCanvasElement((prevPages) => {
                        let temp = prevPages.map((page) => {
                            if (page?.id !== canvasPageSelect) {
                                return { ...page }
                            }
                            else {
                                const updatedElements = page?.elements.map((item) => {
                                    let form_form_column_data = item?.form_form_column_data || []
                                    let form_form_column_data_first = form_form_column_data.find((_) => true) || {}
                                    let code = form_form_column_data_first?.code || ""
                                    if (code !== "綁定表單") {
                                        return item;
                                    }
                                    let form_column_source_data = form_form_column_data_first?.form_column_source_data || [{}]
                                    let document_source_data = form_column_source_data.find((_) => true)?.document_source_data || [{}]
                                    let updated_document_source_data = document_source_data.map((doc) => {
                                        return {
                                            ...doc,
                                            document_id: changedDocumentId
                                        }
                                    })
                                    let updated_form_column_source_data = form_column_source_data.map((form_column) => {
                                        return {
                                            ...form_column,
                                            document_source_data: updated_document_source_data
                                        }
                                    })
                                    let updated_form_form_column_data = form_form_column_data.map((form_column) => {
                                        return {
                                            ...form_column,
                                            form_column_source: true,
                                            form_column_source_data: updated_form_column_source_data
                                        }
                                    })

                                    return {
                                        ...item,
                                        form_form_column_data: updated_form_form_column_data
                                    };
                                });
                                return {
                                    ...page,
                                    elements: updatedElements,
                                };
                            }

                        })

                        if (baseCanvasEdit2Ref.current) {
                            baseCanvasEdit2Ref.current.onUpdate(temp)
                        }
                        return prevPages
                    });
                }}
                children={<div className=" md:flex-row   bg-gray-50">
                    <div className="flex flex-col md:flex-row  bg-gray-50">
                        {/* 左側：BaseCanvasEdit1 */}
                        <div className="w-full md:w-64 border-r border-gray-200 bg-white flex-shrink-0 z-index-10">
                            <BaseCanvasEdit1
                                base_on_classify_structure={base_on_classify_structure}
                                componentData={componentData}
                                selectedComponent={selectedComponentId}
                                onClick={(selectedComponentId) => {
                                    changeSelectedComponent(selectedComponentId);
                                }}
                            />
                        </div>
                        {/* 中間：BaseCanvasEdit2（畫布區） */}
                        <TempDataProvider >
                            <div className="flex-1 min-w-0 flex flex-col">
                                {(propsLoading !== null ? propsLoading : isLoading) ? <Spinner /> :
                                    <BaseCanvasEdit2
                                        formColumnApiRoute={formColumnApiRoute}
                                        tools={tools}
                                        ref={baseCanvasEdit2Ref}
                                        showRulers={false}
                                        elements={canvasElement}
                                        onCanvasElementChange={(canvasElements) => {
                                            setCanvasElement(canvasElements)
                                        }}
                                        onCanvasElementClick={(element) => {
                                            changeSelectedComponent(element?.component_definitions_id)
                                            setElementType(element?.type)
                                            selectCanvasEditElementRef.current = element
                                            // setSelectedCanvasElement(element)
                                        }}
                                        onCanvasPageSelectChange={(page) => {
                                            setCanvasPageSelect(page)
                                        }}
                                        onCanvasPageChange={(page) => {
                                            setCanvasPage(page)
                                            setCanvasElement(page)
                                        }}
                                    />}
                            </div>
                        </TempDataProvider>
                        {/* 右側：BaseCanvasEdit3_1 */}
                        <div className="w-full md:w-80 border-l border-gray-200 bg-white flex-shrink-0">
                            <BaseCanvasEdit3_1
                                selectElementId={selectCanvasEditElementRef.current?.id}
                                showTabkey={showTabkey}
                                selectedComponentId={selectedComponentId}
                                componentAttributesData={componentAttributesData || []}
                                componentCommonAttributesData={componentCommonAttributesData}
                                elementData={selectedElement?.[0]} //被選擇的元件資料
                                elementsData={canvasElement?.flatMap(page => page?.elements || []) || []} //全部畫布元件資料
                                canvasElement={selectCanvasEditElementRef.current}
                                onChangeComponentEffect={(style, modifyType) => { onChangeComponentEffect(style, modifyType) }}
                                onFinishAIResult={(result) => { applyAIContentToSelectedElement(result) }}
                                aiGenerateAPIRoute={aiGenerateAPIRoute}
                                onChangecanvasElement={(values, type) => {
                                    //change form_form_column_data
                                    if (type === "form_form_column_data") {
                                        let form_form_column_data = [values]
                                        setCanvasElement((prevPages) => {
                                            let temp = prevPages.map((page) => {
                                                if (page?.id !== canvasPageSelect) {
                                                    return { ...page }
                                                }
                                                else {
                                                    const updatedElements = page?.elements.map((item) => {

                                                        let selectCanvasEditElementId = selectCanvasEditElementRef.current?.id
                                                        if (item?.id === selectCanvasEditElementId) {
                                                            selectCanvasEditElementRef.current = { ...item, form_form_column_data }
                                                            return {
                                                                ...item,
                                                                form_form_column_data: form_form_column_data
                                                            };
                                                        }
                                                        else {
                                                            return item;
                                                        }
                                                    });
                                                    return {
                                                        ...page,
                                                        elements: updatedElements,
                                                    };
                                                }

                                            })

                                            if (baseCanvasEdit2Ref.current) {
                                                baseCanvasEdit2Ref.current.onUpdate(temp)
                                            }
                                            return prevPages
                                        });
                                    }
                                    else {
                                        setCanvasElement((prevPages) => {
                                            let temp = prevPages.map((page) => {
                                                if (page?.id !== canvasPageSelect) {
                                                    return { ...page }
                                                }
                                                else {
                                                    const updatedElements = page?.elements.map((item) => {

                                                        let selectCanvasEditElementId = selectCanvasEditElementRef.current?.id
                                                        if (item?.id === selectCanvasEditElementId) {
                                                            selectCanvasEditElementRef.current = { ...item, [type]: values }
                                                            return {
                                                                ...item,
                                                                [type]: values
                                                            };
                                                        }
                                                        else {
                                                            return item;
                                                        }
                                                    });
                                                    return {
                                                        ...page,
                                                        elements: updatedElements,
                                                    };
                                                }

                                            })

                                            if (baseCanvasEdit2Ref.current) {
                                                baseCanvasEdit2Ref.current.onUpdate(temp)
                                            }
                                            return prevPages
                                        });
                                    }

                                }}
                                documentFiveWAPI={documentFiveWAPI}
                                fiveWResponseAPI={fiveWResponseAPI}
                                five_w_id={five_w_id}
                                dropDownDocumentController={dropDownDocumentController}
                                dropDownDocumentAPiRoute={dropDownDocumentAPiRoute}
                                fiveWResponseData={fiveWResponseData}
                                allDocumentData={allDocumentData}
                            />
                        </div>
                    </div>



                </div>}
            />
        </div>
    )
})

export default BaseCanvasEdit
